// File for logic corresponding to footer component
import Accordion from '@/js/Accordion';
import { componentProvider } from 'js-component-framework/es';
import './site-footer.scss';

function siteFooter({ children, options }) {
  const items = [];
  const { toggles } = children;
  toggles.forEach((toggle) => {
    items.push(new Accordion(toggle, options));
  });
}

const siteFooterConfig = {
  name: 'site-footer',
  component: siteFooter,
  querySelectorAll: {
    toggles: '.footer-menu__toggle',
  },
  options: {
    breakpoint: 'mdMax',
  },
};

componentProvider(siteFooterConfig);
